import script from "./workload-duration-by-hours-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-duration-by-hours-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__